<h1 mat-dialog-title><span i18n>Potvrdenie</span></h1>
<hr/>
<div mat-dialog-content class="alert p-3 m-3 rounded">
  {{data.message}}
</div>
<hr/>
<div mat-dialog-actions class="d-flex justify-content-end">
  <button class="btn" mat-button [mat-dialog-close]="'KO'"><span i18n>Nie</span></button>
  <button class="btn" mat-button [mat-dialog-close]="'OK'" cdkFocusInitial><span i18n>Áno</span></button>
</div>
